/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_System_Prompt_RequiredInputs */



/**
* | output |
* | --- |
* | "System prompt is required." |
*
* @param {Personas_System_Prompt_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_system_prompt_required = /** @type {((inputs?: Personas_System_Prompt_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_System_Prompt_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("System-Prompt ist erforderlich.")
	return /** @type {LocalizedString} */ ("System prompt is required.")
});